import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'

import TimeModal from '../../common/TimeModal'

import * as Strings from './strings'
import * as configActions from '../../actions/Config'
import * as laundryTimesActions from '../../actions/LaundryTimes'

class NewLaundryTimeModal extends Component {
  state = {
    startTimeInput: '',
    endTimeInput: '',
    errorStartTime: '',
    errorEndTime: '',
    errorMessage: ''
  }

  componentWillReceiveProps(nextProps) {
    const { laundryTimes } = this.props

    if (
      !nextProps.laundryTimes.isCreating &&
      nextProps.laundryTimes.errorCreating === null &&
      laundryTimes.isCreating
    ) {
      this.props.hideCreateLaundryTimeModal()
      this.resetFields()
      this.props.showSnackbar(Strings.default.LAUNDRY_TIME_CREATED)
    } else if (
      !nextProps.laundryTimes.isCreating &&
      nextProps.laundryTimes.errorCreating !== null &&
      laundryTimes.isCreating
    ) {
      this.setState({ errorMessage: Strings.default.INTERNAL_ERROR })
    }
  }

  createLaundryTime() {
    const { data, user } = this.props
    const { startTimeInput, endTimeInput } = this.state

    this.setState({ errorMessage: '' })

    if (startTimeInput === '') {
      this.setState({ errorStartTime: Strings.default.MANDATORY_FIELD })
    }

    if (endTimeInput === '') {
      this.setState({ errorEndTime: Strings.default.MANDATORY_FIELD })
    }

    if (startTimeInput !== '' && endTimeInput !== '') {
      const postData = {
        startTime: startTimeInput,
        endTime: endTimeInput
      }

      this.props.tryCreateLaundryTime(user.token, data.community.id, postData)
    }
  }

  resetFields() {
    this.setState({
      startTimeInput: '',
      endTimeInput: '',
      errorStartTime: '',
      errorEndTime: '',
      errorMessage: ''
    })
  }

  render() {
    const { config, laundryTimes } = this.props
    const {
      startTimeInput,
      endTimeInput,
      errorStartTime,
      errorEndTime,
      errorMessage
    } = this.state

    return (
      <TimeModal
        show={config.createLaundryTimeModal.show}
        hide={() => {
          this.resetFields()
          this.props.hideCreateLaundryTimeModal()
        }}
        startTimeInput={startTimeInput}
        onChangeStartTimeInput={text =>
          this.setState({
            startTimeInput: text,
            errorStartTime: '',
            errorMessage: ''
          })
        }
        errorStartTime={errorStartTime}
        endTimeInput={endTimeInput}
        onChangeEndTimeInput={text => {
          this.setState({
            endTimeInput: text,
            errorEndTime: '',
            errorMessage: ''
          })
        }}
        errorEndTime={errorEndTime}
        header={Strings.default.NEW_LAUNDRY_TIME}
        information={Strings.default.NEW_LAUNDRY_TIME_INFORMATION}
        onDone={() => this.createLaundryTime()}
        loading={laundryTimes.isCreating}
        errorMessage={errorMessage}
      />
    )
  }
}

function mapStateToProps({ config, data, user, laundryTimes }) {
  return { config, data, user, laundryTimes }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    { ...configActions, ...laundryTimesActions },
    dispatch
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(NewLaundryTimeModal)



// WEBPACK FOOTER //
// ./src/components/containers/NewLaundryTimeModal/index.js